import React from "react"

const IndexPage = () => <h1>Hi people</h1>

export default IndexPage
